import { render, staticRenderFns } from "./PaginateList.vue?vue&type=template&id=664a3de8&scoped=true&"
import script from "./PaginateList.vue?vue&type=script&lang=js&"
export * from "./PaginateList.vue?vue&type=script&lang=js&"
import style0 from "./PaginateList.vue?vue&type=style&index=0&id=664a3de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664a3de8",
  null
  
)

export default component.exports